import { render, staticRenderFns } from "./PageJumbotron.vue?vue&type=template&id=6d7f3b1e&scoped=true"
import script from "./PageJumbotron.vue?vue&type=script&lang=js"
export * from "./PageJumbotron.vue?vue&type=script&lang=js"
import style0 from "./PageJumbotron.vue?vue&type=style&index=0&id=6d7f3b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7f3b1e",
  null
  
)

export default component.exports